import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function finalizeSignoffResponse(
   signoff_requestid: number,
   token: string,
   response_value: boolean,
   response_feedback: string,
   common: CommonRequestOptions = {}
): Promise<void> {
   return await makeRequest(
      'post',
      `courses/stage-sign-offs/responses/${signoff_requestid}/finalize`,
      {
         ...common,
         body: {
            token,
            response_value,
            response_feedback,
         },
      }
   );
}
